<template>
    <div class="warp_echart" :style="{marginRight:'1.1%'}">
        <div v-if="EChartArray.small == true" :id="EChartArray.id" :style="{ boxSizing:'border-box', width: '100%',backgroundColor:'#FFF',height: '298px',float:'left',paddingBottom:'10px',paddingTop:'10px'}"></div>
        <div v-else :id="EChartArray.id" :style="{width:'100%',height:'298px'}" class="echartDiv"></div>
    </div>
</template>
<style  lang="scss">
.warp_echart{
    margin-right:2%;
    &:last-child{
      margin-right: 0 !important;
    }
}
</style>
<script>
import theme from '@/assets/js/theme';
export default {
  name: 'ArEcharts',
    watch: {
        EChartArray () {
            this.drawEChart()
        },
    },
    props:['EChartArray'],
    methods:{
        drawEChart() {
            this.$echarts.registerTheme('theme', theme)
            var myChart = this.$echarts.init(document.getElementById(this.EChartArray.id), 'theme');
            window.addEventListener("resize", function() {
                myChart.resize();
            }); 
            if(this.EChartArray.type == undefined){
                var series = [];
                this.EChartArray.data.ydata.map((item,index,array) =>{
                    series.push({
                        type : 'line',
                        name : item.name,
                        data : item.data,
                        smooth: true
                    })
                })
                myChart.setOption({
                    title: {
                        left: this.EChartArray.titleLeft == undefined ? 'center' :  this.EChartArray.titleLeft,  
                        text: this.EChartArray.titleText,
                        subtext: this.EChartArray.subtext == undefined ? '' :  this.EChartArray.subtext,  
                    },
                    legend: this.EChartArray.legend,
                    xAxis: {
                        type: 'category',
                        data: this.EChartArray.data.xdata,
                        name: this.EChartArray.name.xname,
                    },  
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            animation: false,
                            label: {
                                backgroundColor: '#505765'
                            }
                        }
                    },
                    yAxis: {
                        name: this.EChartArray.name.yname,
                        type: 'value',
                        axisLabel: {
                            formatter: this.EChartArray.name.label == undefined ? '{value}' : this.EChartArray.name.label
                        }
                    },
                    toolbox: {
                        show: true,
                        itemSize: 12,
                        right: this.EChartArray.toolboxRight == undefined ? 20 : this.EChartArray.toolboxRight,
                        top:  this.EChartArray.toolboxTop == undefined ? '' : this.EChartArray.toolboxTop,
                        feature: {
                            dataZoom: {
                                yAxisIndex: 'none'
                            },
                            //          dataView: {readOnly: false},
                            magicType: {
                                type: ['line', 'bar']
                            },
                            restore: {},
                            //          saveAsImage: {}
                        }
                    },
                    series:series
                },true)
            }else{
                myChart.setOption({
                    title: {
                        left: 'center',
                        text: this.EChartArray.titleText,
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    series : [
                        {
                            name: '用户',
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '50%'],
                            data: this.EChartArray.data,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                })
            }
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/echarts/echarts.vue